import {
    PlusOutlined,
} from "@ant-design/icons";
import {
    Button,
    Col,
    ConfigProvider,
    DatePicker,
    FloatButton,
    Row,
    Select,
    Space,
    Spin,
    Switch,
    Table,
    Tag,
    Tooltip,
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { Footer } from "antd/es/layout/layout";
import frFR from "antd/locale/fr_FR";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import NavBar from "../../../components/NavBar";
import SideBar from "../../../components/SideBar";
import { rightsService } from "../../../services/rightsService";
import axiosInstance from "../../../variables/api/axiosInstance";
import { LOGGED_USER } from "../../../variables/constants";
import {
    frenchDate,
    frenchDateSimple,
} from "../../../variables/functions";
import { displayNumbers } from "../../../variables/numbersFunctions";
import { StatCard } from "../../../components/statistics/StatCard";
import { COLORS } from "../../../components/ui/colors";

const { RangePicker } = DatePicker;

const dateFormat = "DD/MM/YYYY";

const Propositions = () => {
    const [total, setTotal] = useState(0);
    const [data, setData] = useState([]);
    const [selecting, setSelecting] = useState(false);
    const [loadingContrats, setLoadingContrats] = useState(true);
    const [membres, setMembres] = useState([]);
    const [filteredInfo, setFilteredInfo] = useState({});
    const [sortedInfo, setSortedInfo] = useState({});
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [banques, setBanques] = useState([]);
    const [count, setCount] = useState("");

    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedCompagnies, setSelectedCompagnies] = useState([]);
    const [bulkCorbeilleLoading, setBulkCorbeilleLoading] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, showSizeChanger: true });

    // Habilitation dédiée : seul un utilisateur disposant de HCO092 peut mettre des
    // propositions dans la corbeille (toggle « Mode sélection » + action en masse).
    const canCorbeille = rightsService("HCO092");

    const columns = [
        {
            title: "Numero de devis",
            dataIndex: "numeroPolice",
            key: "1",
        },
        {
            title: "Souscripteur",
            dataIndex: "souscripteur",
            key: "2",
        },
        {
            title: "Organisme",
            dataIndex: "organisme",
            key: "3",
        },
        {
            title: "Date Effet",
            dataIndex: "dateEffet",
            key: "4",
        },
        {
            title: "Date Echeance",
            dataIndex: "dateEcheance",
            key: "5",
        },
        {
            title: "Prime nette",
            dataIndex: "primeNette",
            key: "primeNette",
        },
        {
            title: "Accessoires",
            dataIndex: "accessoires",
            key: "accessoires",
        },
        {
            title: "Taxes",
            dataIndex: "taxes",
            key: "taxes",
        },
        {
            title: "Prime TTC",
            dataIndex: "primeTotale",
            key: "primeTotale",
        },
        Table.EXPAND_COLUMN,
        {
            title: "Actions",
            dataIndex: "actions",
            key: "7",
            render: (_, record) => (
                <Tooltip title="Détails">
                    <button
                        type="button"
                        className="btn btn-primary btn-icon rounded-pill"
                        onClick={() => navigate(`/details-contrat/${record.codeId}`)}
                    >
                        <i className="bx bx-dots-vertical-rounded"></i>
                    </button>
                </Tooltip>
            ),
        },
    ];

    const navigate = useNavigate();

    // onChange du Table : pagination/tri/filtres de COLONNE (regle). Les filtres serveur
    // (période + compagnies) restent gérés à part → paginer ne les efface plus.
    const handleChange = (pag, filters, sorter) => {
        setFilteredInfo(filters);
        setSortedInfo(sorter);
        fetchData(pag.current, pag.pageSize);
    };

    const handleDateChange = (dates, dateStrings) => {
        const [sDate, eDate] = dateStrings || [];
        // Effacement du filtre période (RangePicker vidé) → on retire la contrainte de date.
        if (!sDate || !eDate) {
            setSelectedDate(null);
            fetchData(1, pagination.pageSize, { date: null });
            return;
        }
        const [startDay, startMonth, startYear] = sDate.split("/");
        const [endDay, endMonth, endYear] = eDate.split("/");
        const startDate = `${startYear}-${startMonth}-${startDay}`;
        const endDate = `${endYear}-${endMonth}-${endDay}`;
        const newDate = [startDate, endDate];
        setSelectedDate(newDate);
        // Filtre modifié → on revient à la première page.
        fetchData(1, pagination.pageSize, { date: newDate });
    };

    // Récupère une page. `page`/`size` sont explicites ; les filtres serveur (période +
    // compagnies) sont lus dans l'état, sauf override passé dans `opts` (utile juste après
    // un setState, dont la valeur n'est pas encore visible).
    const fetchData = async (page = 1, size = 10, opts = {}) => {
        const date = opts.date !== undefined ? opts.date : selectedDate;
        const comps = opts.compagnies !== undefined ? opts.compagnies : selectedCompagnies;
        setLoadingContrats(true);
        try {
            const queryParams = { page: page - 1, size };
            if (date && date[0] && date[1]) {
                queryParams.startDate = date[0];
                queryParams.endDate = date[1];
            }
            if (comps && comps.length) {
                queryParams.compagnie = comps.join(",");
            }
            const response = await axiosInstance.get("/api/contrat/proposition", { params: queryParams });
            const { content, totalElements } = response.data;
            // console.log("Total element; ", totalElements);
            console.log(" element; ", content);
            let ctrs = [];
            const uniqueContrats = Array.from(
                new Map((content || []).map((contrat) => [contrat.codeId, contrat])).values()
            );
            uniqueContrats.forEach((contrat, key) => {
                ctrs.push({
                    key: contrat.codeId,
                    codeId: contrat.codeId,
                    id: key,
                    numeroPolice: contrat.numeroPoliceM
                        ? contrat.numeroPoliceM
                        : contrat.numeroPoliceP,
                    souscripteur: contrat?.prenom
                        ? `${contrat?.prenom} ${contrat?.nom}`
                        : `${contrat?.nom}`,
                    organisme: contrat?.raisonSociale,
                    dateEffet: contrat?.dateEffet
                        ? `${frenchDate(contrat?.dateEffet)}`
                        : "",
                    dateEcheance: contrat?.dateEcheance
                        ? `${frenchDateSimple(contrat?.dateEcheance)} `
                        : "",
                    primeTotale: new Intl.NumberFormat("en-DE", { maximumFractionDigits: 0 }).format(contrat?.primeTotale),
                    taxes: new Intl.NumberFormat("en-DE", { maximumFractionDigits: 0 }).format(contrat?.primeTotale * 0.06 / 1.06),
                    primeNette: new Intl.NumberFormat("en-DE", { maximumFractionDigits: 0 }).format(contrat?.primeNette),
                    accessoires: new Intl.NumberFormat("en-DE", { maximumFractionDigits: 0 }).format(contrat?.accessoires),
                    data: contrat,
                });
            });
            setData(ctrs);
            setPagination((prev) => ({
                ...prev,
                current: page,
                pageSize: size,
                total: totalElements,
            }));
            setTotal(totalElements);
        } catch (error) {
            console.error("Failed to fetch data:", error);
        } finally {
            setLoadingContrats(false);
        }
    };

    // Chargement initial + données de référence (UNE SEULE FOIS au montage). La pagination
    // et les filtres déclenchent désormais fetchData directement (handleChange /
    // handleDateChange / filteringOnCompanies) — plus de rechargement des listes de
    // référence à chaque changement de page.
    useEffect(() => {
        fetchData(1, 10);

        axiosInstance
            .get(`/api/parametre/type/BANQUE`)
            .then((res) => {
                setBanques(res.data);
            })
            .catch((err) => {
                console.log(err);
            });

        axiosInstance
            .get(`/api/organisme/assurance`)
            .then((res) => {
                let membs = [];
                res.data.forEach((memb, index) => {
                    membs.push({
                        key: index,
                        text: memb.raisonSociale,
                        value: memb.code,
                        data: memb,
                    });
                });
                membs.push({
                    key: "DTRF",
                    text: "DTRF",
                    value: "DTRF",
                });
                membs.push({
                    key: "DTRF-Lome",
                    text: "DTRF-LOME",
                    value: "LOME",
                });
                membs.push({
                    key: "DTRF-Kpalime",
                    text: "DTRF-KPALIME",
                    value: "KPALIME",
                });
                membs.push({
                    key: "DTRF-Atakpame",
                    text: "DTRF-ATAKPAME",
                    value: "ATAKPAME",
                });
                membs.push({
                    key: "DTRF-Sokode",
                    text: "DTRF-SOKODE",
                    value: "SOKODE",
                });
                membs.push({
                    key: "DTRF-Kara",
                    text: "DTRF-KARA",
                    value: "KARA",
                });
                membs.push({
                    key: "DTRF-Dapaong",
                    text: "DTRF-DAPAONG",
                    value: "DAPAONG",
                });
                membs.push({
                    key: "STCA",
                    text: "STCA",
                    value: "STCA",
                });
                setMembres(membs);
            })
            .catch((err) => {
                console.log(err);
            });

        axiosInstance
            .get(`/api/contrat/count`)
            .then((res) => {
                console.log("Count: ", res.data);
                setCount(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const filteringOnCompanies = (companies) => {
        setSelectedCompagnies(companies);
        // Filtre modifié → on revient à la première page.
        fetchData(1, pagination.pageSize, { compagnies: companies });
    };

    // Mise en corbeille des propositions SÉLECTIONNÉES (sélection multiple). Envoie la liste
    // des codeId au backend, puis rafraîchit la liste et vide la sélection.
    const handleBulkCorbeille = () => {
        if (!selectedRowKeys || selectedRowKeys.length === 0) {
            return;
        }
        setBulkCorbeilleLoading(true);
        axiosInstance
            .put(`/api/contrat/proposition/corbeille`, selectedRowKeys)
            .then(() => {
                toast.success(
                    `${selectedRowKeys.length} proposition(s) déplacée(s) dans la corbeille.`
                );
                setSelectedRowKeys([]);
                setSelectedRows([]);
                setSelecting(false);
                fetchData(pagination.current, pagination.pageSize);
            })
            .catch((err) => {
                const msg = err?.response?.data?.message
                    || "Erreur lors de la mise en corbeille des propositions";
                toast.error(msg);
            })
            .finally(() => setBulkCorbeilleLoading(false));
    };

    const onSelectChange = (newSelectedRowKeys, rows) => {
        // console.log("selectedRowKeys changed: ", newSelectedRowKeys);
        // console.log("SelectedRows", rows);
        setSelectedRows(rows);
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };


    return (
        <div class="layout-wrapper layout-content-navbar  ">
            <div class="layout-container">
                <SideBar currentMenu={"PRODUCTION"} />

                {/* <!-- Layout container --> */}
                <div class="layout-page">
                    <NavBar />

                    {/* <!-- Content wrapper --> */}
                    <div class="content-wrapper">
                        {/* <!-- Content --> */}
                        <div class="container-xxl flex-grow-1 container-p-y">
                            <Row style={{ marginBottom: "15px", justifyContent: "space-between" }}>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Contrats"
                                        subtitle="Total contrats"
                                        value={displayNumbers(total || 0)}
                                        icon="bx bx-file"
                                        iconBg={COLORS.secondary}
                                        gradient={COLORS.secondary}
                                    />
                                </Col>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Contrats validés"
                                        subtitle="Nbre total actifs / Nbre total validés"
                                        value={`${count?.activeCount ? displayNumbers(count?.activeCount) : 0} / ${count?.valideCount ? displayNumbers(count?.valideCount) : 0}`}
                                        icon="bx bx-check-circle"
                                        iconBg={COLORS.secondary}
                                        gradient={COLORS.secondary}
                                    />
                                </Col>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Contrats annulés"
                                        subtitle="Contrats annulés"
                                        value={displayNumbers(count?.annuleCount || 0)}
                                        icon="bx bx-x-circle"
                                        iconBg={COLORS.secondary}
                                        gradient={COLORS.secondary}
                                    />
                                </Col>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Contrats en attente"
                                        subtitle="Contrats en Proposition"
                                        value={displayNumbers(count?.enPropositionCount || 0)}
                                        icon="bx bx-time-five"
                                        iconBg={COLORS.secondary}
                                        gradient={COLORS.secondary}
                                    />
                                </Col>
                                <Col
                                    flex="1"
                                    style={{
                                        minWidth: "180px",
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Corbeille"
                                        subtitle="Propositions en corbeille"
                                        value={displayNumbers(count?.corbeilleCount || 0)}
                                        icon="bx bx-trash"
                                        iconBg={COLORS.secondary}
                                        gradient={COLORS.secondary}
                                    />
                                </Col>
                            </Row>
                            {/* <!-- Users List Table --> */}
                            <div class="row">
                                <div class="col-sm-4">
                                    {rightsService("HCO022") ||
                                        rightsService("HCO005") ||
                                        rightsService("HCO019") ? (
                                        <Button
                                            type="primary"
                                            icon={<PlusOutlined />}
                                            style={{ marginBottom: 16, backgroundColor: COLORS.secondary }}
                                            onClick={() => navigate("/ajouter-contrat-new")}
                                        >
                                            Nouveau contrat
                                        </Button>
                                    ) : null}
                                </div>
                            </div>

                            <div class="card">
                                <div class="container">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="row">
                                                {canCorbeille && (
                                                    <div class="col-4">
                                                        <Space align="center" style={{ marginBottom: 16 }}>
                                                            Mode sélection:{" "}
                                                            <Switch
                                                                checked={selecting}
                                                                onChange={setSelecting}
                                                            />
                                                        </Space>
                                                    </div>
                                                )}
                                                <div class="col-4">
                                                    <RangePicker
                                                        format={dateFormat}
                                                        onChange={handleDateChange}
                                                        placeholder="Filtre par date"
                                                    />
                                                </div>
                                                {LOGGED_USER?.profil?.organisme?.typeOrganisme === "POOL" && (LOGGED_USER?.agence?.typeAgence === "SIEGE" || LOGGED_USER?.agence === null) ?
                                                    <div class="col-4">
                                                        <Select
                                                            mode="multiple"
                                                            placeholder="Filtre par compagnie"
                                                            onChange={filteringOnCompanies}
                                                            options={membres.map((memb) => (
                                                                {
                                                                    label: memb.text,
                                                                    value: memb.value,
                                                                    key: memb.value
                                                                }
                                                            ))}
                                                            style={{ width: "80%" }}
                                                        />
                                                    </div> : null}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <ConfigProvider locale={frFR}>
                                    <Spin spinning={loadingContrats}>
                                        <Table
                                            rowSelection={selecting ? rowSelection : null}
                                            columns={columns}
                                            rowKey="codeId"
                                            dataSource={data}
                                            onChange={handleChange}
                                            pagination={{
                                                ...pagination,
                                                showSizeChanger: true,
                                                pageSizeOptions: ["10", "20", "50", "100"],
                                                showTotal: (total) => `${total} proposition(s)`,
                                            }}
                                        />
                                    </Spin>
                                </ConfigProvider>
                            </div>
                        </div>

                        {/* Barre d'action de sélection multiple : apparaît dès qu'au moins une
                            proposition est sélectionnée (mode sélection actif). */}
                        {canCorbeille && selecting && selectedRowKeys.length > 0 && (
                            <div
                                style={{
                                    position: "fixed",
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    zIndex: 1000,
                                    background: "#fff",
                                    boxShadow: "0 -2px 10px rgba(0,0,0,0.15)",
                                    padding: "12px 24px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-end",
                                    gap: 16,
                                }}
                            >
                                <span style={{ fontWeight: 600 }}>
                                    {selectedRowKeys.length} proposition(s) sélectionnée(s)
                                </span>
                                <Button onClick={() => { setSelectedRowKeys([]); setSelectedRows([]); }}>
                                    Annuler la sélection
                                </Button>
                                <Button
                                    type="primary"
                                    danger
                                    icon={<DeleteOutlined />}
                                    loading={bulkCorbeilleLoading}
                                    onClick={handleBulkCorbeille}
                                >
                                    Mettre dans la corbeille
                                </Button>
                            </div>
                        )}

                        {/* Bouton flottant d'accès à la corbeille (sous habilitation HCO092). */}
                        {canCorbeille && (
                            <FloatButton
                                icon={<DeleteOutlined />}
                                type="primary"
                                tooltip="Corbeille des propositions"
                                style={{ right: 24, bottom: 24 }}
                                onClick={() => navigate("/corbeille-propositions")}
                            />
                        )}
                        {/* <!-- / Content --> */}

                        {/* <!-- Footer --> */}
                        <Footer />
                        {/* <!-- / Footer --> */}

                        <div class="content-backdrop fade"></div>
                    </div>
                    {/* <!-- Content wrapper --> */}
                </div>
                {/* <!-- / Layout page --> */}
            </div>

            {/* <!-- Overlay --> */}
            <div class="layout-overlay layout-menu-toggle"></div>

            {/* <!-- Drag Target Area To SlideIn Menu On Small Screens --> */}
            <div class="drag-target"></div>
        </div>
    );
};

export default Propositions;
